import { Stage } from './stage';

export const CropTypes = {
  None: '',
  WineGrapes: 'Wine Grapes',
  TableGrapes: 'Table Grapes',
  JuiceGrapes: 'Juice Grapes',
  VineNursery: 'Vine Nursery',
  Blueberries: 'Blueberries',
  Raspberries: 'Raspberries',
  Cherries: 'Cherries',
  Blackberries: 'Blackberries',
  Citrus: 'Citrus',
  Plums: 'Plums',
  Experimental: 'Experimental',
  Fallow: 'Fallow',
} as const;

export type CropType = (typeof CropTypes)[keyof typeof CropTypes];

export type Variety = {
  id: string;
  customerID: string;
  name: string;
  cropType: CropType;
  stages: Stage[];
};
